import { useState, useCallback } from 'react';

export type TabItem = {
  pathname: string;
  title: string;
};

const HOME_TAB: TabItem = {
  pathname: '/',
  title: '首页',
};

export default () => {
  const [tabList, setTabList] = useState<TabItem[]>([HOME_TAB]);
  const [activeKey, setActiveKey] = useState<string>(HOME_TAB.pathname);

  const addTab = useCallback((tab: TabItem) => {
    setTabList((prev) => {
      const exists = prev.find((item) => item.pathname === tab.pathname);
      if (exists) {
        return prev;
      }
      return [...prev, tab];
    });
    setActiveKey(tab.pathname);
  }, []);

  const closeTab = useCallback((key: string) => {
    setTabList((prev) => {
      if (prev.length === 1) return prev;
      const next = prev.filter((item) => item.pathname !== key);
      if (!next.find((item) => item.pathname === activeKey)) {
        setActiveKey(next[next.length - 1]?.pathname || HOME_TAB.pathname);
      }
      return next.length > 0 ? next : [HOME_TAB];
    });
  }, [activeKey]);

  const closeOthers = useCallback((key: string) => {
    setTabList((prev) => {
      const keep = prev.filter((item) => item.pathname === key || item.pathname === HOME_TAB.pathname);
      setActiveKey(key);
      return keep.length > 0 ? keep : [HOME_TAB];
    });
  }, []);

  const closeAll = useCallback(() => {
    setTabList([HOME_TAB]);
    setActiveKey(HOME_TAB.pathname);
  }, []);

  return {
    tabList,
    activeKey,
    setActiveKey,
    addTab,
    closeTab,
    closeOthers,
    closeAll,
  };
};

